import { InventorySummary } from '../services/inventoryService';

export const getStockStatusColor = (summary?: InventorySummary) => {
  if (!summary) return 'default';
  if (summary.availableCases === 0) return 'error';
  if (summary.belowMinimum) return 'error';
  if (summary.belowThreshold) return 'warning';
  return 'success';
};

export const getStockStatusLabel = (summary?: InventorySummary) => {
  if (!summary) return 'UNKNOWN';
  if (summary.availableCases === 0) return 'OUT OF STOCK';
  if (summary.belowMinimum) return 'CRITICAL';
  if (summary.belowThreshold) return 'LOW';
  return 'GOOD';
};
